import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompleteComponent } from './autocomplete.component';
/**
 * NgModule definition for the AutoComplete component.
 */
export class AutoCompleteModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        AutoCompleteComponent
    ],
    exports: [
        AutoCompleteComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AutoCompleteModule_tsickle_Closure_declarations() {
/** @type {?} */
AutoCompleteModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AutoCompleteModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
